<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil bwlist" style="background:#fff;">
            <a-card>
                <div class="search">
                    <a-button type="primary" @click="addshow">添加来访语</a-button>
                </div>
                <a-table
                :columns="columns"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                :data-source="data"
                >
                    <span slot="action" slot-scope="text, record">
                        <a-button type="primary" :size="size"  @click="editmodal(index,$event)" :id="record.id"><a-icon type="edit" />编辑</a-button>
                        <a-button type="danger" :size="size" @click="deletguest(index,$event)" :id="record.id"><a-icon type="delete" />删除</a-button>
                    </span>
                </a-table>
            </a-card>
        </div>

         <!-- 添加 -->
        <a-modal
            class="pwdmodal"
            title="添加来访语"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="addrolemodal"
            :confirm-loading="confirmLoading"
            @ok="addguest"
            @cancel="handleCancel"
        >
             <a-row>
                <a-col :span="5">
                    <label class="required-icon">来访语内容：</label>
                </a-col>
                <a-col :span="16">
                    <a-textarea :rows="6" v-model="content" placeholder="请输入来访语内容"></a-textarea>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >排序：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="sort" placeholder="请输入排序（数字越小越靠前）"></a-input>
                </a-col>
            </a-row>
        </a-modal>

        <!-- 编辑 -->
        <a-modal
            class="pwdmodal"
            title="编辑来访语"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="editrolemodal"
            :confirm-loading="confirmLoading"
            @ok="editguest"
            @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">来访语内容：</label>
                </a-col>
                <a-col :span="16">
                    <a-textarea :rows="6" v-model="editinfo.content" placeholder="请输入来访语内容"></a-textarea>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>排序：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.sort" placeholder="请输入排序（数字越小越靠前）"></a-input>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '来访语内容',
    dataIndex: 'content',
    key: 'content',
    width:600
  },
  {
    title: '排序',
    dataIndex: 'sort',
    key: 'sort',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  }
];


export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '来访语管理'},
            ],
            data:"",
            columns,
            pagination: {},
            loading: false,
            size:'small',
            content:"",
            sort:"",
            editinfo:"",
            confirmLoading:false,
            editrolemodal:false,
            addrolemodal:false,
            id:"",
            currentpagination:"",
        }
    },
    mounted(){
        this.fetch()
        // this.$axios.get('/api/getmessagelist',{
        //     headers: {
        //         "appid": this.appSet.appid,
        //         "appkey": this.appSet.appkey,
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.data=res.data.data.lists
        //     }
        // })
    },
    methods:{
        // 删除
        deletguest(index,event){
            var editid=event.currentTarget.id
            Modal.confirm({
                title: '提示',
                content: '您确定删除此来访语吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(editid)
                },
                onCancel() {

                },
            });
        },
        handok(editid){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delguest',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==40014){
                    this.$message.warning(res.data.msg); 
                }else if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                }else{
                    this.$message.success(res.data.msg);
                }
            })
        },
        handleCancel(){
            this.addrolemodal=false
            this.editrolemodal=false
        },
        editguest(){
            var params=new URLSearchParams()
            params.append('id',this.id)
            params.append('content',this.editinfo.content)
            params.append('sort',this.editinfo.sort)
            this.$axios.post('/api/editguest',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('编辑成功'); 
                    this.editrolemodal=false
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        addguest(){
            var params=new URLSearchParams()
            params.append('content',this.content)
            params.append('sort',this.sort)
            this.$axios.post('/api/addguest',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('添加成功'); 
                    this.addrolemodal=false
                    this.fetch();
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        editmodal(index,event){
            this.editrolemodal=true
            var id=event.currentTarget.id
            this.id=id
            this.$axios.get('/api/getguestinfo',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id: id,
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.editinfo=res.data.data
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
            
        },
        addshow(){
            this.addrolemodal=true
        },
        search(){
            this.fetch()
        },
        // 消息详情
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },

        fetch(params = {}) {

            params=JSON.parse(JSON.stringify(params).replace(/sortOrder/g, 'order'));
        
            if(params.order=='descend'){
                params.order=2
            }else{
                params.order=1
            }
            console.log('params:', params);
            if(params.type){
                params.type=params.type[0]
            }

            this.loading = true;
            this.$axios.get('/api/guestlist',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                    this.currentpagination=pagination
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },

    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/guest.vue